export const APP_VERSION = '0.53.0';
